import { makeStyles, Text } from '@rneui/themed'
import { View } from 'react-native'

interface NotFoundComponentProps {
  title: string
  description?: string
}

export function NotFoundComponent({
  title,
  description,
}: NotFoundComponentProps) {
  const styles = useStyles()
  return (
    <View style={styles.notFoundComponent}>
      <Text h3 style={styles.notFoundComponentText}>
        {title}
      </Text>
      {description && (
        <Text h4 style={styles.notFoundComponentText}>
          {description}
        </Text>
      )}
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  notFoundComponent: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  notFoundComponentText: {
    color: theme.colors?.grey0,
  },
}))
